import { render } from "./FpuiCanvasMode.vue?vue&type=template&id=b041ec7a&lang=pug"
import script from "./FpuiCanvasMode.vue?vue&type=script&lang=js"
export * from "./FpuiCanvasMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__